module.exports = __webpack_public_path__ + "img/room-size_brand.d6b033be.svg";